import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import { Link } from 'react-router-dom';
import CotalityDeveloperPortalLogo from '../../assets/images/logo.png';

export const HeaderLogo = () => (
  <Link to="/" style={{ textDecoration: 'none' }}>
    <Stack direction="row" alignItems="center" gap={1.5}>
      <Box
        component="img"
        src={CotalityDeveloperPortalLogo}
        alt="Cotality Developer Portal"
        height={32}
      />
    </Stack>
  </Link>
);
